import { IApplicationState } from '../../types/redux';

export const selectGeocode = (state: IApplicationState) => state.filters.geocode;
